import Divider from "./Divider";
import { ReactNode } from "react";

type AreaContentBlockProps = {
  title: string | ReactNode;
  text: string | ReactNode;
  className?: string;
  variant?: "default" | "homepage";
  headingLevel?: "h1" | "h2";
};

export default function AreaContentBlock({
  title,
  text,
  className = "",
  variant = "default",
  headingLevel = "h1",
}: AreaContentBlockProps) {
  const isHomepage = variant === "homepage";
  const HeadingTag = headingLevel;
  
  return (
    <div className={`w-full text-left min-w-0 break-words ${isHomepage ? "lg:max-w-[600px] xl:max-w-[640px]" : ""} ${className}`}>
      <HeadingTag className="text-[clamp(1.5rem,6vw,2rem)] sm:text-[clamp(2rem,5vw,2.75rem)] md:text-[clamp(2.25rem,4vw,3rem)] lg:text-4xl xl:text-5xl font-normal leading-[105%] sm:leading-[105%] md:leading-[100%] lg:leading-[100%] tracking-normal text-white mb-2 sm:mb-4 md:mb-6 lg:mb-[1.5625rem]">
        {title}
      </HeadingTag>

      <Divider className="mx-0 w-full !mt-0 !mb-0" />

      <p className={`mt-2 sm:mt-4 md:mt-6 lg:mt-[1.5625rem] text-[0.8125rem] sm:text-base md:text-[1.0625rem] ${isHomepage ? "lg:text-[0.9375rem] xl:text-base" : "lg:text-lg xl:text-xl"} font-normal ${isHomepage ? "leading-[135%] sm:leading-[140%] md:leading-[130%] lg:leading-[145%] xl:leading-[145%]" : "leading-[135%] sm:leading-[140%] md:leading-[130%] lg:leading-[140%] xl:leading-[135%]"} tracking-normal text-white/70`}>
        {text}
      </p>
    </div>
  );
}
